import React from 'react';
export const ConfigurationContext = React.createContext(undefined);
//# sourceMappingURL=configuration-context.js.map